export enum OnecardOptions {
	points = 'points',
}
